import { LightSplashPanelRegister } from './LightSplashPanelRegister';

export const SplashPanelRegister = () => {
  /* TODO: Rename the light theme and make it the main one */
  return <LightSplashPanelRegister />;
};
